import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase, { auth } from "../../lib/firebase";
import Utils from "../../Utils";
import ar from "../../locale";
import { deleteUrl } from "../../constants";

export default class VideosReviewed extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      videosReviewed: [],
      token: null,
      deleting: {},
    };
    this.hobbyRef = firebase.database().ref("hobbyvideos/");
    this.commentRef = firebase.database().ref("comments/hobbyvideos/");
  }

  componentDidMount() {
    super.componentDidMount();
    auth.currentUser.getIdToken().then((token) => {
      this.state.token = token;
      this.updateState();
    });
    this.hobbyRef
      .orderByChild("reviewed")
      .equalTo(this.props.reviewed)
      .on("value", (response) => {
        this.state.videosReviewed = Utils.convertToArrayWithOrderKeyDesc(
          response.val(),
          "on"
        );
        this.updateState();
      });
    window.Tablesaw.init(this.$("#sawtable"));
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.hobbyRef.off("value");
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  loadDetails = (key) => {
    this.props.history.push("/my-hobby/" + key);
  };

  renderSlide = (video) => {
    return (
      <tr key={video.key}>
        <td
          className="title cursor-pointer"
          onClick={this.loadDetails.bind(this, video.key)}
        >
          <img
            src={video.poster}
            className="img-fluid"
            width="100"
            height=""
            alt="video"
          />
        </td>
        <td
          className="title cursor-pointer"
          onClick={this.loadDetails.bind(this, video.key)}
        >
          <p className="mb-0 mt-1">
            {video.photoUrl && (
              <img
                src={video.photoUrl}
                alt="avatar"
                className="avatarc rounded-circle"
                width="30"
                height="30"
              />
            )}
            <span className="pl-1 pr-1">{video.name}</span>
          </p>
          <p className="mb-0 mt-1">
            {ar.country} - {video.country} , {ar.age} - {video.age}
          </p>
        </td>
        <td>
          {!this.state.deleting[video.key] && (
            <i
              className="fa fa-trash text-danger cursor-pointer"
              title={ar.delete}
              onClick={this.deleteConfirmation.bind(this, video)}
            ></i>
          )}
          {this.state.deleting[video.key] && (
            <div
              className="d-inline-block spinner-border spinner-border-sm text-danger"
              role="status"
            ></div>
          )}
        </td>
      </tr>
    );
  };

  deleteConfirmation = (video) => {
    this.confirm(null, this.deleteSlide.bind(this, video));
  };

  deleteSlide = (video) => {
    this.state.deleting[video.key] = true;
    this.updateState();
    fetch(deleteUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      body: JSON.stringify({
        path: "hobbyvideos/" + video.key,
      }),
    })
      .then((response) => this.deleteComments(video))
      .then(() => {
        this.updateState();
      })
      .catch((error) => {
        this.state.deleting[video.key] = false;
        this.showError(error.message);
      });
  };

  deleteComments = (video) => {
    return this.commentRef.child(video.key).remove();
  };

  render() {
    let { videosReviewed } = this.state;
    let { reviewed } = this.props;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card no-toolbar border-0 mb-0">
              <div className="card-body pl-0 pr-0">
                <div className="row">
                  <div className="col-12 mt-2">
                    <h4 className="card-title">
                      {reviewed && ar.reviewed_videos}
                      {!reviewed && ar.unreviwed_videos}
                    </h4>
                    <h5 className="card-subtitle">
                      {ar.total} {videosReviewed.length}
                    </h5>
                  </div>
                </div>
                <table
                  id="sawtable"
                  className="mt-3 tablesaw table-bordered table-striped table-hover table no-wrap"
                  data-tablesaw-mode="swipe"
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        data-tablesaw-sortable-col
                        data-tablesaw-priority="2"
                        className="border"
                      >
                        {ar.video}
                      </th>
                      <th
                        scope="col"
                        data-tablesaw-sortable-col
                        data-tablesaw-priority="3"
                        className="border"
                      >
                        {ar.name}
                      </th>
                      <th scope="col" className="border">
                        {ar.delete}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {videosReviewed.map((video, index) =>
                      this.renderSlide(video)
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
